"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const fields = [
    "connectEnd",
    "connectStart",
    "decodedBodySize",
    "domainLookupEnd",
    "domainLookupStart",
    "duration",
    "encodedBodySize",
    "entryType",
    "fetchStart",
    "initiatorType",
    "name",
    "nextHopProtocol",
    "redirectEnd",
    "redirectStart",
    "requestStart",
    "responseEnd",
    "responseStart",
    "secureConnectionStart",
    // serverTiming is a array. Server API does not support arrays
    //serverTiming,
    "startTime",
    "transferSize",
    "workerStart",
    // workerTiming is a array. Server API does not support arrays
    //workerTiming: []
];
function serializePerformanceEntry(entry) {
    const data = entry.toJSON();
    return fields.reduce((val, key) => ({ ...val, [`performance.${key}`]: data[key] }), {});
}
exports.default = serializePerformanceEntry;
